import { getDayOffIdByTitle } from '@/pages/Onboarding/options/DayOff/utils/getDayOff';
import { getFlawIdByTitle } from '@/pages/Onboarding/options/Flaw/utils/getFlaw';
import { getFlirtingStyleIdByTitle } from '@/pages/Onboarding/options/FlirtingStyle/utils/getFlirtingStyle';
import { getHisPastIdByTitle } from '@/pages/Onboarding/options/HisPast/utils/getHisPast';
import { getHisTypeIdByTitle } from '@/pages/Onboarding/options/HisType/utils/getHisType';
import { getHisVoiceIdByTitle } from '@/pages/Onboarding/options/HisVoice/utils/getHisVoice';
import { getHobbiesInterestsIdByTitle } from '@/pages/Onboarding/options/HobbiesInterests/utils/getHobbiesInterests';
import { getHowOftenReachOutIdByTitle } from '@/pages/Onboarding/options/HowOftenReachOut/utils/getHowOftenReachOut';
import { getIdealFirstDateIdByTitle } from '@/pages/Onboarding/options/IdealFirstDate/utils/getIdealFirstDate';
import { getNoticeFirstIdByTitle } from '@/pages/Onboarding/options/NoticeFirst/utils/getNoticeFirst';
import { getOutnessIdByTitle } from '@/pages/Onboarding/options/Outness/utils/getOutness';
import { getRelationshipImportantIdByTitle } from '@/pages/Onboarding/options/RelationshipImportant/utils/getRelationshipImportant';
import { getRoleInRelationshipIdByTitle } from '@/pages/Onboarding/options/RoleInRelationship/utils/getRoleInRelationship';
import { getShowLoveIdByTitle } from '@/pages/Onboarding/options/ShowLove/utils/getShowLove';
import { getWhatYouWantIdByTitle } from '@/pages/Onboarding/options/WhatYouWant/utils/getWhatYouWant';

import { layoutDataDefault } from '../constants';
import { LayoutDataType } from '../types';

type LayoutDataTypeFromUser = Omit<
  LayoutDataType,
  | 'notice_first'
  | 'his_type'
  | 'his_voice'
  | 'show_love'
  | 'his_past'
  | 'what_you_want'
  | 'how_often_reach_out'
  | 'flirting_style'
  | 'ideal_first_date'
  | 'flaw'
  | 'hobbies_interests'
  | 'outness'
  | 'relationship_important'
  | 'role_in_relationship'
  | 'day_off'
> & {
  notice_first: string;
  his_type: string;
  his_voice: string;
  show_love: string;
  his_past: string;
  what_you_want: string;
  how_often_reach_out: string;
  flirting_style: string;
  ideal_first_date: string;
  flaw: string;
  hobbies_interests: string;
  outness: string;
  relationship_important: string;
  role_in_relationship: string;
  day_off: string;
};

export const normalizeOnbDataToForm = (
  onb_data: LayoutDataTypeFromUser,
): LayoutDataType => {
  return {
    ...layoutDataDefault,
    notice_first: getNoticeFirstIdByTitle(onb_data.notice_first),
    his_type: getHisTypeIdByTitle(onb_data.his_type),
    his_voice: getHisVoiceIdByTitle(onb_data.his_voice),
    show_love: getShowLoveIdByTitle(onb_data.show_love),
    his_past: getHisPastIdByTitle(onb_data.his_past),
    what_you_want: getWhatYouWantIdByTitle(onb_data.what_you_want),
    how_often_reach_out: getHowOftenReachOutIdByTitle(
      onb_data.how_often_reach_out,
    ),
    flirting_style: getFlirtingStyleIdByTitle(onb_data.flirting_style),
    ideal_first_date: getIdealFirstDateIdByTitle(onb_data.ideal_first_date),
    flaw: getFlawIdByTitle(onb_data.flaw),
    hobbies_interests: getHobbiesInterestsIdByTitle(onb_data.hobbies_interests),
    outness: getOutnessIdByTitle(onb_data.outness),
    relationship_important: getRelationshipImportantIdByTitle(
      onb_data.relationship_important,
    ),
    role_in_relationship: getRoleInRelationshipIdByTitle(
      onb_data.role_in_relationship,
    ),
    day_off: getDayOffIdByTitle(onb_data.day_off),
    personality: onb_data.personality || layoutDataDefault.personality,
    name: onb_data.name || layoutDataDefault.name,
    email: onb_data.email || layoutDataDefault.email,
  };
};
